import { useMemo } from "react"
import { groupConversionsByStep } from "@/shared/utils/conversionsByStep"

export const ConversionsByJourneyStep = ({ data }: { data: any }) => {
  const groups = useMemo(
    () => groupConversionsByStep(data?.["conversions-by-journey-step"] ?? []),
    [data],
  )

  if (groups.length === 0) {
    return <p className="text-muted mb-0">No journey step data available.</p>
  }

  return (
    <ul className="list-unstyled mb-0">
      {groups.map((group) => {
        // Undimensioned step: one plain row (subtotal == the single cell).
        if (!group.dimensioned) {
          return (
            <li
              key={group.journey_step_id ?? group.step_name}
              className="d-flex align-items-center justify-content-between py-2 border-bottom"
            >
              <span className="fw-semibold">{group.step_name}</span>
              <span className="text-muted">{group.total.toLocaleString()}</span>
            </li>
          )
        }

        // Dimensioned step: subtotal header + a row per (dimension) cell.
        return (
          <li key={group.journey_step_id ?? group.step_name} className="border-bottom">
            <div className="d-flex align-items-center justify-content-between py-2">
              <span className="fw-semibold">{group.step_name}</span>
              <span className="fw-semibold">{group.total.toLocaleString()}</span>
            </div>
            <ul className="list-unstyled mb-0">
              {group.cells.map((cell, idx) => (
                <li
                  key={cell.dimension_id ?? `cell-${idx}`}
                  className="d-flex align-items-center justify-content-between py-1 ps-3"
                >
                  <span className="text-muted">{cell.dimension_name ?? "Unspecified"}</span>
                  <span className="text-muted">{cell.conversions.toLocaleString()}</span>
                </li>
              ))}
            </ul>
          </li>
        )
      })}
    </ul>
  )
}
